export interface PaginatedResponse<T> {
    count: number;
    next: string | null;
    previous: string | null;
    results: T[];
}

export interface UserCompanyStatusResponse {
    company: {
        id: string;
        status: number;
        name: string;
        email: string;
        [key: string]: unknown;
    };
    email_verified: boolean;
    offerterms_eligible: boolean;
    [key: string]: unknown;
}
